export const buildEventByRawEvent = (rawEventName: string) => {
  return {
    event_id: undefined,
    event_name: rawEventName,
    rules: [
      [
        {
          key: 'all_event_name',
          mapping_rules: [],
          metadata: [],
          op: 'eq',
          value: [rawEventName],
        },
      ],
    ],
    event_category: 'Custom',
    related_metrics: [],
    related_flows: [],
  };
};
